/**
 * LlmReasoningEngine — thin client-side wrapper around the
 * `reasoning-engine` Supabase edge function, which runs the real LLM
 * behind the Lovable AI Gateway.
 *
 * The engine itself lives server-side so LOVABLE_API_KEY never touches
 * the browser. This class satisfies the same `ReasoningEngine` interface
 * as the placeholder, so the harness and dev tools can swap between them
 * without conditional code paths.
 */

import { supabase } from "@/integrations/supabase/client";
import type { EngineOutput } from "../types";
import type { EngineInput, ReasoningEngine } from "./engine";

export class LlmReasoningEngine implements ReasoningEngine {
  readonly name = "llm-gemini-3-flash";
  readonly version = "0.1.0";

  async analyze(input: EngineInput): Promise<EngineOutput> {
    const { data, error } = await supabase.functions.invoke("reasoning-engine", {
      body: input,
    });

    if (error) {
      throw new Error(`Reasoning engine call failed: ${error.message ?? "unknown"}`);
    }
    if (!data || typeof data !== "object") {
      throw new Error("Reasoning engine returned no data");
    }
    if ("error" in data && data.error) {
      throw new Error(String(data.error));
    }

    return data as EngineOutput;
  }
}
